import { groupCapabilityTemplates } from './groupHelpers.js';
export const simpleGroupTemplateIds = [
    'publicGroup',
    'localGroup',
    'privateGroup',
    'announcementGroup',
    'lockedGroup',
];
const TEMPLATE_RELATIONSHIPS = [
    'none',
    'local',
    'member',
    'moderator',
    'admin',
    'owner',
];
const normalizeBucket = (bucket) => {
    var _a, _b;
    return ({
        add: [...((_a = bucket === null || bucket === void 0 ? void 0 : bucket.add) !== null && _a !== void 0 ? _a : [])].sort(),
        remove: [...((_b = bucket === null || bucket === void 0 ? void 0 : bucket.remove) !== null && _b !== void 0 ? _b : [])].sort(),
    });
};
export const normalizeGroupCapabilitiesForMatch = (capabilities) => {
    var _a, _b;
    const normalized = {};
    for (const relationship of TEMPLATE_RELATIONSHIPS) {
        const bucket = capabilities === null || capabilities === void 0 ? void 0 : capabilities[relationship];
        if (!((_a = bucket === null || bucket === void 0 ? void 0 : bucket.add) === null || _a === void 0 ? void 0 : _a.length) && !((_b = bucket === null || bucket === void 0 ? void 0 : bucket.remove) === null || _b === void 0 ? void 0 : _b.length))
            continue;
        normalized[relationship] = normalizeBucket(bucket);
    }
    return normalized;
};
export const groupCapabilitiesMatchTemplate = (capabilities, templateCapabilities) => JSON.stringify(normalizeGroupCapabilitiesForMatch(capabilities)) ===
    JSON.stringify(normalizeGroupCapabilitiesForMatch(templateCapabilities));
export const getSimpleGroupTemplateCapabilities = (templateId) => {
    const template = groupCapabilityTemplates[templateId];
    return structuredClone(template.capabilities);
};
export const matchSimpleGroupTemplate = (capabilities) => {
    for (const templateId of simpleGroupTemplateIds) {
        if (groupCapabilitiesMatchTemplate(capabilities, groupCapabilityTemplates[templateId].capabilities)) {
            return templateId;
        }
    }
    return 'custom';
};
export const applySimpleGroupTemplate = (templateId) => getSimpleGroupTemplateCapabilities(templateId);
export const defaultSimpleGroupTemplate = (publicContent) => (publicContent ? 'publicGroup' : 'localGroup');
export const simpleGroupTemplateOptions = (publicContent) => simpleGroupTemplateIds.filter((id) => publicContent || id !== 'publicGroup');
